import axios from 'axios';
import { useAuthService } from '@trp-ta-nitro/auth-react';
import { useState } from 'react';
import { log } from '../Utils.js';

const axiosInstance = axios.create({
    withCredentials: true,
    timeout: 25000,
    headers: {
        'Cache-Control': 'no-cache',
        Accept: 'application/json',
        'X-TRP-Requested-With': 'XMLHttpRequest',
    },
});

export const axiosDocumentInstance = axios.create({
    withCredentials: true,
    timeout: 60000,
    headers: {
        'Cache-Control': 'no-cache',
        Accept: 'application/json',
        'X-TRP-Requested-With': 'XMLHttpRequest',
    },
});

export const AxiosInterceptor = ({ children }) => {
    const authService = useAuthService();
    const [authState, setAuthState] = useState({});
    const listener = (auth) => setAuthState(auth);
    authService.listenAuthState(listener);

    const validateAuthSession = (req) => {
        if (JSON.stringify(authState) === '{}' || authState.authenticated) {
            return req;
        }
        log(console.log('This user is no longer logged in! Blocking their requests!'));
        throw new Error('User is no longer logged in.');
    };

    const onError = (err) => Promise.reject(err);

    axiosInstance.interceptors.request.use(validateAuthSession, onError);
    axiosDocumentInstance.interceptors.request.use(validateAuthSession, onError);

    return children;
};

export default axiosInstance;
